module.exports = __webpack_public_path__ + "img/exit.3a6a4ba1.svg";